import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { Button, TextField } from "@mui/material";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Swal from "sweetalert2";
import Toast from "../../utils/Toast";

import useCreateReferralcode from "../../mutation/referralCode/createReferralcode";
import useCreateAudit from "../../mutation/audit/createAudit";
import {
  FormPageShell,
  FormPageCard,
  FormPageHeader,
  FormActions,
} from "../../components/ListPage";

const schema = yup.object().shape({
  reservationId: yup.number().required("reservationId is required"),
});

const NewReferralcode = (props) => {
  const history = useHistory();

  const [createResponse, setData] = useCreateReferralcode();
  const [auditResponse, setAuditData] = useCreateAudit();

  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const goBack = () => {
    window.location.href = "/dashboard/referralCodes";
  };

  /* const requirementChange = (value) => {
    if (value != null) {
      setValue("requirement", { label: value.label, value: value.value });
    }
  }; */

  const onSubmit = (values) => {
    let dataObj = {};
    dataObj.reservationId = values.reservationId;

    //setData(dataObj);
    // do audit stuff:
    Swal.fire({
      title: "Create Manual Referral",
      html: `<h4>Please provide a description before submitting your changes</h4>
      <textarea maxlength="100" type="text" id="actionDescription" class="swal2-input" placeholder="Description" font-size=18px style="height:auto!important" rows=5>`,
      confirmButtonText: "Confirm",
      focusConfirm: false,
      preConfirm: () => {
        const actionDescription =
          Swal.getPopup().querySelector("#actionDescription").value;
        if (!actionDescription) {
          Swal.showValidationMessage(`Please enter description`);
        }
        return {
          actionDescription: actionDescription,
          newData: dataObj,
          type: "referral-codes",
          action: "createManual",
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log(result.value);
        setAuditData(result.value);
      }
    });
    /* } */
  };

  useEffect(() => {
    try {
      if (auditResponse.data) {
        Toast.fire({
          icon: "success",
          title: "Audit created",
        });
        history.push("/dashboard/referralCodes");
      } else if (auditResponse.error) {
        let data = auditResponse.errorMessage.response.data;
        if (data) {
          let messageData = data.message;
          let message = messageData.message;

          Swal.fire({
            icon: "error",
            title: "Error",
            text: message,
          });
        }
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message,
      });
    }
  }, [auditResponse]);

  useEffect(() => {
    try {
      console.log(createResponse);
      if (createResponse.data && "status" in createResponse.data) {
        if (createResponse.data.status == "success") {
          Toast.fire({
            icon: "success",
            title: "Referral Code created",
          });
          history.push("/dashboard/referralCodes");
        } else if (createResponse.data.status == "failed") {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: createResponse.data.message,
          });
        }
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message,
      });
    }
  }, [createResponse]);

  const renderContent = () => {
    return (
      <FormPageShell>
        <form noValidate onSubmit={handleSubmit(onSubmit)}>
          <FormPageCard>
            <FormPageHeader
              title="New Referral Code"
              onBack={goBack}
              subtitle="Please fill in the required fields."
            />
            <TextField
              name="reservationId"
              margin="normal"
              fullWidth
              label="Reservation ID*"
              variant="outlined"
              inputRef={register}
              error={errors.reservationId != null}
              helperText={
                errors.reservationId != null
                  ? errors.reservationId.message
                  : null
              }
              disabled={createResponse.loading}
            />
          </FormPageCard>
          <FormPageCard sx={{ mt: 2 }}>
            <FormActions>
              <Button
                type="submit"
                size="large"
                variant="contained"
                color="primary"
                disabled={createResponse.loading}
              >
                Submit
              </Button>
            </FormActions>
          </FormPageCard>
        </form>
      </FormPageShell>
    );
  };

  return <div>{renderContent()}</div>;
};

export default NewReferralcode;
